import "../js/components/header.js";
// import "../js/components/akkordion.js";
// import "../js/components/horizontal-scroller.js";
import "../js/components/sliders.js";
import "../js/components/form.js";
import * as flsFunctions from "../js/components/functions.js";

/*
Модуль работы со спойлерами
Документация:
Сниппет (HTML): spollers
*/
flsFunctions.spollers();
